/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc
 */

export const getApprovalConfigurationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovalConfiguration',
  auth: 'app',
  fingerprint: '5raw4qLtibfz3W9LwEzzjoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApprovalSkipConfigurationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovalSkipConfiguration',
  auth: 'app',
  fingerprint: 'h7ykx7XAA7wf6ciFrFmEW4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const putApprovalSkipConfigurationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putApprovalSkipConfiguration',
  auth: 'app',
  fingerprint: 'vKWKxB5mtoeRmprYFbsWtoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApproversRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovers',
  auth: 'app',
  fingerprint: 'MQXgpSUgriCv1wchydvePIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const putApprovalConfigurationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putApprovalConfiguration',
  auth: 'app',
  fingerprint: 'XHETXAwg2A_xryw2ZYDnRoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendRequestToEnableApprovalsRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'sendRequestToEnableApprovals',
  auth: 'app',
  fingerprint: 'vzjBIqVUnjW_GCjzXfbQCYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};